/* Oneso Shop Video — shoppable video playlist for a wishlist delivery or All Wish List Styles. Works like the Oneso Live Studio player: Shop panel with every style, product panel with sizes and Add to cart, wishlist heart, share, cart (opens the SparkLayer cart over the player), sound, minimize. The video always starts silent (muted: true in build); "Tap for sound" (bottom left, above the controls) or the sound button turns it on.
   Search and filters, the same as the Video Shop (assets/bayeas-video-shop.js): a search box, mic and Filters button at the top of the Shop panel, a Wishlist chip and style chips under it, and a search button on the right of the video ("/" on a keyboard). Typed or spoken sentences are understood ("high rise wide leg in light blue under $35 that ships now"). Wispr Flow (or any dictation app) types straight into the search box and the styles update as the words arrive; the mic uses the browser's own speech recognition. The Filters menu has Sort by, Style, Collection, Tag, Size range, Rise, Wash / Color, Availability, Ships, Season, Stretch, Inseam, Details, Vibe and Wholesale price; each section folds open and shut (tap its heading) and Collapse all / Expand all sits at the top. The video plays only the styles that match.
   Rise, color, season, stretch, status, inseam, fabric and collections come from /products/HANDLE?view=video-meta (templates/product.video-meta.liquid; collections are the ones in the site's header menu, snippets/bayeas-video-colls.liquid). The search and filter look comes from assets/bayeas-video-shop.css, loaded when the player opens (its address is set in snippets/bayeas-delivery-video-playlist.liquid).
   The version before search and filters is saved as assets/bayeas-shop-video-backup-2026-10-27.js. */
(function () {
'use strict';
if (window.OnesoShopVideo) return;
var L = window.BSVL; if (!L || !L.openSheet) return;
var d = L.d, mk = L.mk, btn = L.btn, ibtn = L.ibtn, ICON = L.ICON, setIcon = L.setIcon, base = L.base;
var PHOTO_MS = 5000, cache = {}, U = null;
L.brand();
/* "Tap for sound": the button on the silent video (bottom left, above the product card and controls) that turns the sound on.
   Same button as the Grid Line Sheet and Video Line Sheet players. */
(function () {
if (d.getElementById('bsv-tfs-css')) return;
var s = mk('style'); s.id = 'bsv-tfs-css';
s.textContent = '.bsv .bay-tfs{align-self:flex-start;display:inline-flex;align-items:center;gap:7px;height:34px;padding:0 14px 0 11px;border:0;border-radius:999px;background:rgba(70,70,70,.82);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:#fff;font:inherit;font-size:13px;font-weight:700;line-height:1;white-space:nowrap;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.25)}.bsv .bay-tfs:hover{background:rgba(40,40,40,.92)}.bsv .bay-tfs svg{width:16px;height:16px;flex:none}.bsv .bay-tfs[hidden]{display:none}';
d.head.appendChild(s);
})();
/* Search and filters: the theme shows empty boxes (div:empty) on purpose for the player's pictures; these stay hidden when empty */
(function () {
if (d.getElementById('bsv-find-tw')) return;
var s = mk('style'); s.id = 'bsv-find-tw';
s.textContent = '.bsv .bvs-said:empty,.bsv .bvs-tip:empty,.bsv .bvs-chips[hidden],.bsv .bvs-ctrls[hidden]{display:none}';
d.head.appendChild(s);
})();
/* the Video Shop stylesheet (search box, chips, Filters menu), loaded the first time the player opens */
function findCss() {
if (d.getElementById('bsv-find-css') || d.querySelector('link[href*="bayeas-video-shop.css"]')) return;
var href = window.BSV_FIND_CSS; if (!href) return;
var l = mk('link'); l.id = 'bsv-find-css'; l.rel = 'stylesheet'; l.href = href; d.head.appendChild(l);
}
function isMobile() { try { return matchMedia('(max-width: 820px), (pointer: coarse) and (max-width: 1100px)').matches; } catch (e) { return false; } }
var bg = L.bg, mmss = L.mmss;

/* ---------- search and filters (same as the Video Shop) ---------- */
var IC = {
search: 'M10.5 3a7.5 7.5 0 1 1 0 15a7.5 7.5 0 1 1 0-15z M21 21l-5.2-5.2',
mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3z M5 11a7 7 0 0 0 14 0 M12 18v3 M8.5 21h7',
filt: 'M3 6h18 M6.5 12h11 M10 18h4'
};
var TXT = { ph: 'Search or say a style', tip: 'Voice search: tap the mic, or click the search box and dictate with Wispr Flow. Try “high rise wide leg in light blue that ships now.”' };
var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var MONF = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
var GROUPS = [['style', 'Style'], ['coll', 'Collection'], ['tag', 'Tag'], ['size', 'Size range'], ['rise', 'Rise'], ['color', 'Wash / Color'], ['avail', 'Availability'], ['ship', 'Ships'], ['season', 'Season'], ['stretch', 'Stretch'], ['inseam', 'Inseam'], ['detail', 'Details'], ['vibe', 'Vibe'], ['price', 'Wholesale price']];
var SORTS = [['feat', 'Featured'], ['new', 'Newest'], ['ship', 'Ships soonest'], ['plh', 'Price: low to high'], ['phl', 'Price: high to low'], ['sn', 'Style #']];
var PRICE_B = ['Under $25', '$25 – $29.99', '$30 – $34.99', '$35 – $39.99', '$40 and up'];
var RISE_O = ['Low Rise', 'Mid Rise', 'Mid-High Rise', 'High Rise', 'Super High Rise'];
var NOW = Date.now(), STOP = {};
('a an and any are about all also am be by can could do does dont find for from get give got have help hey hi i im in into is it its just ' +
'like looking look me my need of on one ones only or our please pls see show some something that the them these they this those to um uh ' +
'us want wanna we what which with would you your yeah ok okay jeans jean denim pants pant pair pairs style styles product products video videos ' +
'item items color colors colour colours wash washes shade shades let lets bayeas search shop shopping buy order ordering got gotta new').split(' ').forEach(function (w) { STOP[w] = 1; });
var STYLE_SYN = { wideleg: ['wide leg', 'wide legged', 'wideleg', 'palazzo', 'wide'], bootcut: ['bootcut', 'boot cut', 'boot leg', 'bootleg'], flare: ['flare', 'flared', 'flares', 'bell bottom', 'bell bottoms'],
straight: ['straight', 'straight leg'], skinny: ['skinny', 'skinnies'], barrel: ['barrel', 'barrel leg', 'horseshoe'], tapered: ['tapered', 'taper'], shorts: ['shorts', 'jorts'], skirt: ['skirt', 'skirts'],
jacket: ['jacket', 'jackets', 'jean jacket', 'trucker'], vest: ['vest', 'vests'], shirt: ['shirt', 'shirts', 'top', 'tops', 'blouse', 'blouses'], corset: ['corset', 'corsets', 'cami'], dress: ['dress', 'dresses'], capri: ['capri', 'capris'],
mom: ['mom', 'mom jeans', 'mom jean', 'mom fit', 'moms'], boyfriend: ['boyfriend', 'boyfriend fit', 'boyfriend jeans'], bermuda: ['bermuda', 'bermudas', 'bermuda shorts'], romper: ['romper', 'rompers'],
overall: ['overall', 'overalls'], jumpsuit: ['jumpsuit', 'jumpsuits'], harem: ['harem'], cargo: ['cargo', 'cargos'] };
['jacket', 'skirt', 'shirt', 'dress', 'romper', 'overall', 'jumpsuit', 'vest', 'corset', 'capri'].forEach(function (k) { STYLE_SYN[k + (k === 'dress' ? 'es' : 's')] = STYLE_SYN[k] || [k]; });
STYLE_SYN.skirts = STYLE_SYN.skirt; STYLE_SYN.short = STYLE_SYN.shorts; STYLE_SYN.flares = STYLE_SYN.flare;
var TSYN = { dark: ['dark', 'rinse', 'indigo', 'raw', 'black', 'navy', 'deep'], light: ['light', 'bleach', 'baby blue', 'sky', 'ice', 'pale', 'ecru', 'white'], medium: ['medium', 'mid blue'], mid: ['mid', 'medium'],
black: ['black', 'charcoal'], white: ['white', 'ecru', 'cream', 'ivory'], grey: ['grey', 'gray'], gray: ['grey', 'gray'], pink: ['pink', 'rose', 'blush'], distressed: ['distress', 'ripped', 'destroy'],
ripped: ['ripped', 'distress', 'destroy'], embroidered: ['embroider'], embroidery: ['embroider'], rhinestones: ['rhinestone'], plus: ['plus'], curvy: ['plus'] };
/* Tag filter: the style's tags, without the store's working tags: anything with ":" ("NuOrder Active: true"), tags that are not plain
   English letters, Craft- and Vibe- tags (the Details and Vibe filters), season codes (the Season filter), tags with numbers (dates, codes), tags that are a style name (the Style filter) and the retailer, channel, people and working names below. */
var TAG_HIDE = /nuorder|nordstrom|qvc|joor|faire|fashiongo|dillard|burlington|bloomingdale|macy|amazon|tjx|marshalls|walmart|target|shein|zulily|prebook|available from|b2b|wholesale|distributor|immediate|dsco|canada|katie|jenna|clear ?out|blitz|need|\bshows?\b|^plus$|^pre$|pre-?order/i;
function skeys(v) { var w = String(v).toLowerCase().replace(/[^a-z]/g, ''); return [w, w.replace(/s$/, ''), w.replace(/es$/, '')]; }
function tagList(tags) {
var seen = {}, out = [];
(tags || []).forEach(function (t) {
t = String(t == null ? '' : t).replace(/\s+/g, ' ').trim(); var k = t.toLowerCase();
if (!t || seen[k] || t.length > 40 || t.indexOf(':') > -1 || /[^\x20-\x7e]/.test(t) || /^(craft|vibe)-/i.test(t) || /^(FW|SS|HO)\d{2}$/i.test(t) || /\d/.test(t) || TAG_HIDE.test(t)) return;
seen[k] = 1; out.push(t);
});
return out;
}
/* Filters menu sections fold open and shut (tap the heading). Each buyer's choice is kept in this browser; until they choose,
   Sort by and Style are open and the rest are shut unless something in them is picked. */
var FOPEN = {}; try { FOPEN = JSON.parse(localStorage.getItem('bvs-fopen') || '{}') || {}; } catch (e) {}
function isOpen(g, on) { return FOPEN[g] != null ? !!FOPEN[g] : (g === 'sort' || g === 'style' || !!on); }
function setOpen(g, v) { FOPEN[g] = !!v; try { localStorage.setItem('bvs-fopen', JSON.stringify(FOPEN)); } catch (e) {} }
/* S: the search state for the open player. S.all = every style in this Shop Video, S.items = the styles that match. */
function fresh() { return { all: [], items: [], q: '', sel: {}, sort: 'feat', P: null, px: [], v: null, loaded: false, fuzzy: false, more: {}, fd: null, liked: false, wk: false }; }
var S = fresh();
function tc(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim().replace(/(^|[\s\/(-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
function norm(s) {
return ' ' + String(s == null ? '' : s).toLowerCase().replace(/[‘’'\u0060"“”]/g, '').replace(/&/g, ' and ')
.replace(/\.(?!\d)/g, ' ').replace(/[^a-z0-9$.]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
}
function frac(s) { var m = /(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+))?/.exec(String(s || '')); if (!m) return NaN; var n = parseFloat(m[1]); if (m[2]) n += m[2] / m[3]; return n; }
function riseOf(s) {
s = String(s || '').toLowerCase();
if (/super[\s-]*high|ultra[\s-]*high|extra[\s-]*high/.test(s)) return 'Super High Rise';
if (/\bm[\s-]high|mid[\s-]high/.test(s)) return 'Mid-High Rise';
if (/hig[he][\s-]*(rise|waist)/.test(s)) return 'High Rise';
if (/mid[\s-]*rise|medium[\s-]*rise/.test(s)) return 'Mid Rise';
if (/low[\s-]*rise/.test(s)) return 'Low Rise';
return '';
}
function bucket(p) { return p < 25 ? PRICE_B[0] : p < 30 ? PRICE_B[1] : p < 35 ? PRICE_B[2] : p < 40 ? PRICE_B[3] : PRICE_B[4]; }
function uniq(a) { var s = {}, o = []; a.forEach(function (x) { if (x && !s[x]) { s[x] = 1; o.push(x); } }); return o; }
/* A style's search words and filter values, worked out the same way as the Video Shop: from the product (it.full, the
   product's .js) and its metafields (m, from ?view=video-meta; empty until they arrive). */
function prep(it, m, n) {
var p = it.full || {}, v0 = (p.variants || [])[0] || {}; m = m || {};
var tags = p.tags || [], title = String(it.title || p.title || ''), h = String(it.h || ''), f = {}, opts = {};
(p.options || []).forEach(function (o) { if (o && o.name) opts[String(o.name).toLowerCase()] = o.values || []; });
var colorOpt = opts.color || opts.colour || opts.wash || [];
var sn = String(m.sn || '').toUpperCase().trim();
if (!sn) { var g = /\b(BY[A-Z]{0,3}\d{3,5}[A-Z]?)\b/i.exec(title) || /(?:^|-)(by[a-z]{0,3}\d{3,5}[a-z]?)(?:-|$)/i.exec(h) || /-(BY[A-Z0-9]{3,9})-/i.exec(v0.sku || ''); sn = g ? g[1].toUpperCase() : ''; }
if (sn && (m.sn || !it.sn)) it.sn = sn;
var plus = /(^|\s)plus(\s|$)/i.test(title) || /-p$/i.test(h) || /-P$/.test(sn) || /(^|\s)BY[A-Z]{0,3}\d{3,5}[A-Z]?-P(\s|$)/.test(title);
f.style = [tc(p.type) || 'Other'];
f.size = [plus ? 'Plus' : 'Regular'];
var rise = riseOf(m.ri) || riseOf(title); f.rise = rise ? [rise] : [];
f.color = uniq([m.co].concat(colorOpt).map(tc));
var af = null, pre = false;
tags.forEach(function (t) { var x = /available\s*from\s*:?\s*(\d{1,2})\/(\d{1,2})\/(\d{4})/i.exec(t); if (x) af = new Date(+x[3], x[1] - 1, +x[2]); if (/^prebook\s*:\s*true/i.test(t)) pre = true; });
var fut = !!(af && af.getTime() > NOW), st = String(m.ss || '').toUpperCase();
var avail = /PRE/.test(st) ? 'Preorder' : /STOCK/.test(st) ? 'Ready to Ship' : (pre && (fut || !af)) ? 'Preorder' : 'Ready to Ship';
f.avail = [avail];
f.ship = avail === 'Preorder' && fut ? [MON[af.getMonth()] + ' ' + af.getFullYear()] : [];
var se = String(m.se || '').toUpperCase().replace(/\s+/g, '').replace(/^(\d{2})(FW|SS|HO)$/, '$2$1');
f.season = uniq([/^(FW|SS|HO|F|S)\d{2}$/.test(se) ? se : ''].concat(tags.map(function (t) { t = String(t).toUpperCase().trim(); return /^(FW|SS|HO)\d{2}$/.test(t) ? t : ''; })));
f.stretch = m.st ? [tc(m.st)] : [];
var ins = String(m['in'] == null ? '' : m['in']).trim(); f.inseam = ins && /^\d/.test(ins) && !isNaN(frac(ins)) ? [ins.replace(/\s*(in|inch|inches|")$/i, '') + '"'] : [];
f.detail = uniq(tags.map(function (t) { var x = /^craft-\s*(.+)$/i.exec(String(t).trim()); return x && !/basic/i.test(x[1]) ? tc(x[1]) : ''; }));
f.vibe = uniq(tags.map(function (t) { var x = /^vibe-\s*(.+)$/i.exec(String(t).trim()); return x ? tc(x[1]) : ''; }));
f.coll = uniq((m.cl || []).map(function (x) { return String(x).replace(/\s+/g, ' ').trim(); }));
f.tag = tagList(tags);
/* wholesale price: only for signed-in buyers (the same as the prices shown) */
var price = L.loggedIn() && it.price != null && it.price !== '' && !isNaN(parseFloat(it.price)) ? parseFloat(it.price) : null;
f.price = price == null ? [] : [bucket(price)];
var ms = parseFloat(m.ms); if (ms > 0 && !it.m) it.m = ms;
it.n = n; it.fp = price; it.f = f;
it.c = p.created_at ? Math.floor((Date.parse(p.created_at) || 0) / 1000) : 0;
it.shipT = avail === 'Ready to Ship' ? 0 : fut ? af.getTime() : 9e15;
it.sub = [f.color[0], rise, avail === 'Preorder' ? (f.ship[0] ? 'Ships ' + f.ship[0] : 'Preorder') : 'Ready to Ship'].filter(Boolean).join(' · ');
it.hay = norm([title, sn, h.replace(/-/g, ' '), p.type, plus ? 'plus size plus' : 'regular', f.rise, f.color, f.avail, f.ship, f.season, f.stretch, f.detail, f.vibe, m.fa, v0.sku, f.coll, tags.join(' ')].join(' '));
}
/* the style's metafields: /products/HANDLE?view=video-meta (kept for 10 minutes in this browser tab) */
var metaP = {};
function meta(h) {
if (metaP[h]) return metaP[h];
var key = 'bsv-meta:' + h;
try { var c0 = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c0 && Date.now() - c0.t < 600000 && c0.j) return (metaP[h] = Promise.resolve(c0.j)); } catch (e) {}
metaP[h] = fetch(base + 'products/' + encodeURIComponent(h) + '?view=video-meta', { credentials: 'same-origin', headers: { Accept: 'application/json, text/plain, */*' } })
.then(function (r) { if (!r.ok) throw 0; return r.text(); })
.then(function (t) { var j = JSON.parse(t.slice(t.indexOf('{'))); if (!j || typeof j !== 'object') throw 0; try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), j: j })); } catch (e) {} return j; })
.catch(function () { delete metaP[h]; return null; });
return metaP[h];
}
function values(g) {
var cnt = {}; S.all.forEach(function (it) { (it.f[g] || []).forEach(function (v) { cnt[v] = (cnt[v] || 0) + 1; }); });
var vals = Object.keys(cnt);
if ((g === 'coll' || g === 'tag') && S.all.length > 1) vals = vals.filter(function (v) { return cnt[v] < S.all.length; });   /* a collection or tag every style has does not narrow anything */
if (g === 'tag') { var sk = {}; values('style').forEach(function (v) { skeys(v).forEach(function (k) { sk[k] = 1; }); }); vals = vals.filter(function (v) { return !skeys(v).some(function (k) { return sk[k]; }); }); }   /* a tag that is a style name is already in Style */
if (g === 'rise') return RISE_O.filter(function (v) { return cnt[v]; }).concat(vals.filter(function (v) { return RISE_O.indexOf(v) < 0; }));
if (g === 'price') return PRICE_B.filter(function (v) { return cnt[v]; });
if (g === 'avail') return ['Ready to Ship', 'Preorder'].filter(function (v) { return cnt[v]; });
if (g === 'size') return ['Regular', 'Plus'].filter(function (v) { return cnt[v]; });
if (g === 'ship') return vals.sort(function (a, b) { return new Date('1 ' + a) - new Date('1 ' + b); });
if (g === 'inseam') return vals.sort(function (a, b) { return frac(a) - frac(b); });
if (g === 'season') return vals.sort(function (a, b) { var ya = +a.slice(-2), yb = +b.slice(-2); return yb - ya || (a < b ? 1 : -1); });
return vals.sort(function (a, b) { return cnt[b] - cnt[a] || (a < b ? -1 : 1); });
}
function phrasesFor(g, v) {
var lv = norm(v).trim(), k = lv.replace(/ /g, ''), out = [lv];
if (g === 'style') { (STYLE_SYN[k] || []).forEach(function (p) { out.push(p); }); if (!/s$/.test(lv)) out.push(lv + 's'); else if (lv.length > 4 && lv !== 'shorts') out.push(lv.replace(/sses$/, 'ss').replace(/([^s])s$/, '$1')); }
else if (g === 'size') { if (v === 'Plus') out.push('plus size', 'plus sizes', 'plus', 'curvy', 'extended size', 'extended sizes'); else out.push('regular size', 'regular sizes', 'missy', 'standard size'); }
else if (g === 'rise') {
var b = lv.replace(/ rise$/, '');
out.push(b + ' waisted', b + ' waist', b.replace(/ /g, '') + ' rise', b.replace(/ /g, '') + 'rise');
if (b === 'super high') out.push('ultra high rise', 'extra high rise', 'super high');
if (b === 'mid high') out.push('m high rise', 'mid high');
if (b === 'mid') out.push('medium rise');
}
else if (g === 'season') {
var m = /^(fw|ss|ho|f|s)(\d{2})$/.exec(k);
if (m) { var y = m[2], nm = m[1].charAt(0) === 'f' ? ['fall', 'fall winter', 'fall and winter', 'autumn'] : m[1] === 'ho' ? ['holiday'] : ['spring', 'summer', 'spring summer', 'spring and summer']; out.push(m[1] + ' ' + y); nm.forEach(function (n) { out.push(n + ' ' + y, n + ' 20' + y); }); }
}
else if (g === 'ship') {
var mm = /^([a-z]{3}) (\d{4})$/.exec(lv);
if (mm) { var full = MONF[MON.map(function (x) { return x.toLowerCase(); }).indexOf(mm[1])]; if (full) { out.push(full + ' ' + mm[2], full + ' delivery', mm[1] + ' delivery', 'ships in ' + full, 'ship in ' + full, 'ships ' + full, 'delivery in ' + full, 'deliver in ' + full); if (full !== 'may' && full !== 'march') out.push(full); } }
}
else if (g === 'avail') {
if (k === 'readytoship') out.push('ready to ship', 'ready to go', 'in stock', 'instock', 'ships now', 'ship now', 'shipping now', 'available now', 'immediate', 'immediates', 'immediately', 'ship asap', 'asap', 'at once', 'on hand');
else out.push('pre order', 'pre orders', 'preorders', 'prebook', 'pre book', 'coming soon', 'future delivery', 'future');
}
else if (g === 'inseam') { var n = /^(\d+)/.exec(lv); if (n) out.push(n[1] + ' inseam', n[1] + ' inch inseam', 'inseam ' + n[1], n[1] + ' inch'); }
return out;
}
function buildPhraseIndex() {
var seen = {}, list = [];
GROUPS.forEach(function (g) {
if (g[0] === 'price' || g[0] === 'coll' || g[0] === 'tag') return;   /* collections and tags are found as words */
values(g[0]).forEach(function (v) {
phrasesFor(g[0], v).forEach(function (p) { p = String(p).trim(); if (p.length < 2) return; var kk = g[0] + '|' + v + '|' + p; if (seen[kk]) return; seen[kk] = 1; list.push({ g: g[0], v: v, p: p }); });
});
});
list.sort(function (a, b) { return b.p.length - a.p.length; });
S.px = list;
}
function parse(q) {
var P = { fac: {}, hits: [], terms: [], min: null, max: null, liked: false };
var s = norm(q);
if (/^ (clear|reset|start over|clear all|clear everything|clear filters|clear search|show all|show everything|everything|all|all styles) $/.test(s)) { P.reset = true; return P; }
s = s.replace(/ (?:my |in my |on my |from my )?(?:wish ?lists?|wishlisted|likes|liked|liked styles|favou?rites?|saved|saved styles|hearted)(?= )/g, function () { P.liked = true; return ''; });
s = s.replace(/ b y ((?:[a-z] ){0,3})(\d{3,5})(?= )/g, function (m, l, n) { return ' by' + l.replace(/ /g, '') + n; });
s = s.replace(/ (by[a-z]{0,3}) (\d{3,5}[a-z]?)(?= )/g, ' $1$2');
var num = '\\$?(\\d+(?:\\.\\d+)?)(?: dollars| bucks)?';
s = s.replace(new RegExp(' (?:between|from) ' + num + ' (?:and|to) ' + num + '(?= )', 'g'), function (m, a, b) { P.min = Math.min(+a, +b); P.max = Math.max(+a, +b); return ''; });
s = s.replace(new RegExp(' \\$(\\d+(?:\\.\\d+)?) (?:to )?\\$(\\d+(?:\\.\\d+)?)(?= )', 'g'), function (m, a, b) { P.min = Math.min(+a, +b); P.max = Math.max(+a, +b); return ''; });
s = s.replace(new RegExp(' (?:under|below|less than|cheaper than|max|maximum|up to|no more than|at most|within) ' + num + '(?= )', 'g'), function (m, a) { P.max = +a; return ''; });
s = s.replace(new RegExp(' (?:over|above|more than|at least|min|minimum|starting at) ' + num + '(?= )', 'g'), function (m, a) { P.min = +a; return ''; });
S.px.forEach(function (c) {
var needle = ' ' + c.p + ' ';
if (s.indexOf(needle) < 0) return;
while (s.indexOf(needle) > -1) s = s.replace(needle, ' ');
(P.fac[c.g] = P.fac[c.g] || {})[c.v] = true;
P.hits.push(c);
});
s.split(' ').forEach(function (w) { w = w.replace(/^\$+/, ''); if (!w || STOP[w] || w === '.') return; P.terms.push(w); });
return P;
}
function termHit(it, w) {
if (/\d/.test(w)) return it.hay.indexOf(w) > -1;
var alts = TSYN[w] || [w];
for (var i = 0; i < alts.length; i++) if (it.hay.indexOf(' ' + alts[i]) > -1) return true;
if (w.length > 3 && /s$/.test(w) && !TSYN[w]) return termHit(it, w.slice(0, -1));
return false;
}
function passes(it, P, skip, noTerms) {
var g, v;
if ((S.liked || P.liked) && skip !== 'liked' && !it.liked) return false;
for (g in S.sel) {
if (g === skip) continue;
var sv = S.sel[g], has = false, any = false;
for (v in sv) { if (!sv[v]) continue; has = true; if ((it.f[g] || []).indexOf(v) > -1) { any = true; break; } }
if (has && !any) return false;
}
for (g in P.fac) {
if (g === skip) continue;
var hit = false; for (v in P.fac[g]) if ((it.f[g] || []).indexOf(v) > -1) { hit = true; break; }
if (!hit) return false;
}
if (it.fp != null && skip !== 'price') { if (P.min != null && it.fp < P.min) return false; if (P.max != null && it.fp > P.max) return false; }
if (!noTerms) for (var i = 0; i < P.terms.length; i++) if (!termHit(it, P.terms[i])) return false;
return true;
}
function counts(g) { var c = {}; S.all.forEach(function (it) { if (!passes(it, S.P, g)) return; (it.f[g] || []).forEach(function (v) { c[v] = (c[v] || 0) + 1; }); }); return c; }
function nSel() { var n = 0; for (var g in S.sel) for (var v in S.sel[g]) if (S.sel[g][v]) n++; return n; }
function filtersOn() { return !!(nSel() || S.liked || (S.P && (S.P.liked || S.P.hits.length || S.P.terms.length || S.P.min != null || S.P.max != null))); }
function likedOn() { return !!(S.liked || (S.P && S.P.liked)); }
/* Wishlist chip: each style's heart saves to the store's wishlist app; one heart per style is watched to know which styles are liked. */
var likeT = 0;
function watchLike(it) {
if (it._lw || !it.full || !it.full.id) return; it._lw = 1;
if (!it._h) { it._h = L.heart(flash); it._h.bind(it.full); }
var el = it._h.el;
new MutationObserver(function () {
var on = el.getAttribute('aria-pressed') === 'true';
if (el.style.display !== 'none') S.wk = true;
if (on === !!it.liked) return;
it.liked = on; clearTimeout(likeT);
likeT = setTimeout(function () { if (!U) return; if (likedOn()) apply(); else { if (S.v) paintView(S.v); renderFilters(); } }, 120);
}).observe(el, { attributes: true, attributeFilter: ['aria-pressed', 'style'] });
}
function likedCount() { var n = 0; S.all.forEach(function (it) { if (it.liked) n++; }); return n; }
function setLiked(on) { S.liked = !!on; if (!on && S.P && S.P.liked) { setQ(norm(S.q).replace(/ (?:my |in my |on my |from my )?(?:wish ?lists?|wishlisted|likes|liked|liked styles|favou?rites?|saved|saved styles|hearted)(?= )/g, '').trim()); return; } apply(); }
function hasPrices() { return S.all.some(function (it) { return it.fp != null; }); }
function sortList(a) {
var k = S.sort;
if (k === 'feat') return a;
a.sort(function (x, y) {
if (k === 'new') return y.c - x.c || x.n - y.n;
if (k === 'ship') return x.shipT - y.shipT || x.n - y.n;
if (k === 'plh' || k === 'phl') { var px = x.fp == null ? 1e9 : x.fp, py = y.fp == null ? 1e9 : y.fp; return (k === 'plh' ? px - py : (py === 1e9 ? -1 : px === 1e9 ? 1 : py - px)) || x.n - y.n; }
if (k === 'sn') return (x.sn || 'zz').localeCompare(y.sn || 'zz') || x.n - y.n;
return x.n - y.n;
});
return a;
}
function apply() {
var P = S.P = parse(S.q);
if (P.reset) { S.q = ''; S.sel = {}; S.P = P = parse(''); if (S.v && S.v.inp._sync) S.v.inp._sync(''); say('Showing every style'); }
var res = S.all.filter(function (it) { return passes(it, P); });
S.fuzzy = false;
if (!res.length && (P.terms.length || P.hits.length > 1)) {
/* nothing has every word: show the styles that have the most of them (handy for long spoken requests) */
var sc = [], hard = { fac: {}, hits: [], terms: [], min: P.min, max: P.max, liked: P.liked };
S.all.forEach(function (it) {
if (!passes(it, hard)) return;
var n = 0, g, v;
for (g in P.fac) for (v in P.fac[g]) if ((it.f[g] || []).indexOf(v) > -1) { n += g === 'style' ? 3 : 1; break; }
P.terms.forEach(function (w) { if (termHit(it, w)) n++; });
if (n) sc.push([n, it]);
});
sc.sort(function (a, b) { return b[0] - a[0] || a[1].n - b[1].n; });
var top = sc.length ? sc[0][0] : 0;   /* keep the closest ones: missing at most one of the things asked for */
res = sc.filter(function (x) { return x[0] >= top - 1; }).map(function (x) { return x[1]; }); S.fuzzy = res.length > 0;
}
S.items = S.fuzzy ? res : sortList(res);
render();
}
function dropFromQuery(g, v) {
var s = norm(S.q);
(S.P ? S.P.hits : []).forEach(function (h) { if (h.g === g && (v == null || h.v === v)) while (s.indexOf(' ' + h.p + ' ') > -1) s = s.replace(' ' + h.p + ' ', ' '); });
return s.trim();
}
function setQ(q, from) {
q = String(q == null ? '' : q);
if (q === S.q) return;
S.q = q;
if (S.v && S.v.inp !== from && S.v.inp._sync) S.v.inp._sync(q);
apply();
}
function toggle(g, v) {
if (S.P && S.P.fac[g] && S.P.fac[g][v]) { setQ(dropFromQuery(g, v)); return; }
var sv = S.sel[g] = S.sel[g] || {}; if (sv[v]) delete sv[v]; else sv[v] = true;
if (!Object.keys(sv).length) delete S.sel[g];
apply();
}
function clearAll() { S.sel = {}; S.sort = 'feat'; S.liked = false; if (S.q) setQ(''); else apply(); }
function say(t) { if (U && !U.mini) flash(t); else L.toast(t); }
/* search box, mic, Filters button, Wishlist and style chips: at the top of the Shop panel */
function controls() {
var box = mk('div', 'bvs-ctrls bvs-panel'), row = mk('div', 'bvs-sr');
var ic = mk('span', 'bvs-si'); setIcon(ic, IC.search);
var inp = mk('input', 'bvs-in');
inp.type = 'search'; inp.value = S.q; inp.placeholder = TXT.ph;
inp.setAttribute('aria-label', 'Search styles'); inp.autocomplete = 'off'; inp.spellcheck = false;
inp.setAttribute('enterkeyhint', 'search'); inp.setAttribute('autocapitalize', 'off'); inp.setAttribute('autocorrect', 'off');
var clr = btn('bvs-clr', '✕', 'Clear search', function () { setQ(''); inp._sync(''); inp.focus(); });
var mic = btn('bvs-mic', '', 'Search by voice', function () { voice(inp); }); setIcon(mic, IC.mic);
var fb = btn('bvs-fb', '', 'Filters and sort', function () { openFilters(); }); setIcon(fb, IC.filt);
var fbn = mk('b', 'bvs-n'); fb.appendChild(mk('span', null, 'Filters')); fb.appendChild(fbn);
row.appendChild(ic); row.appendChild(inp); row.appendChild(clr); row.appendChild(mic); row.appendChild(fb);
row.addEventListener('click', function (e) { e.stopPropagation(); if (e.target === row || e.target === ic) inp.focus(); });
var said = mk('div', 'bvs-said'), chips = mk('div', 'bvs-chips');
said.setAttribute('aria-live', 'polite'); chips.setAttribute('role', 'group'); chips.setAttribute('aria-label', 'Style');
box.appendChild(row); box.appendChild(said); box.appendChild(chips); box.appendChild(mk('div', 'bvs-tip', TXT.tip));
wireInput(inp);
return { box: box, inp: inp, clr: clr, mic: mic, fbn: fbn, said: said, chips: chips };
}
function wireInput(inp) {
var t = 0, last = inp.value, poll = 0;
function check(now) { if (inp.value === last) return; last = inp.value; clearTimeout(t); if (now) setQ(inp.value, inp); else t = setTimeout(function () { setQ(inp.value, inp); }, 180); }
['input', 'change', 'paste', 'cut', 'compositionend', 'keyup'].forEach(function (ev) { inp.addEventListener(ev, function () { setTimeout(function () { check(false); }, 0); }); });
inp.addEventListener('keydown', function (e) {
e.stopPropagation();   /* typing must not move the player to the next style */
if (e.key === 'Enter') { e.preventDefault(); check(true); if (L.isMobile()) inp.blur(); }
else if (e.key === 'Escape') { e.preventDefault(); if (inp.value) { inp.value = ''; check(true); } else inp.blur(); }
});
/* Wispr Flow and other dictation apps paste the spoken words into the focused box; a light check while it has focus catches any that arrive without a typing event */
inp.addEventListener('focus', function () { clearInterval(poll); poll = setInterval(function () { if (!inp.isConnected) { clearInterval(poll); return; } check(false); }, 300); });
inp.addEventListener('blur', function () { clearInterval(poll); check(true); });
inp.addEventListener('click', L.stop);
inp._sync = function (q) { last = q; if (inp.value !== q) inp.value = q; };
}
function paintView(v) {
var P = S.P || { fac: {}, hits: [], terms: [] }, n = nSel();
v.clr.hidden = !v.inp.value;
v.fbn.textContent = n ? String(n) : ''; v.fbn.hidden = !n;
var bits = [];
if (P.liked) bits.push('♥ your wishlist');
P.hits.forEach(function (h) { var lab = h.v; if (h.g === 'ship') lab = 'Ships ' + h.v; if (h.g === 'season') lab = 'Season ' + h.v; if (h.g === 'inseam') lab = h.v + ' inseam'; if (h.g === 'size') lab = h.v + ' sizes'; if (bits.indexOf(lab) < 0) bits.push(lab); });
if (P.min != null && P.max != null) bits.push('$' + P.min + ' to $' + P.max); else if (P.max != null) bits.push('under $' + P.max); else if (P.min != null) bits.push('over $' + P.min);
P.terms.forEach(function (w) { bits.push('“' + w + '”'); });
v.said.textContent = '';
if (bits.length && S.loaded) {
v.said.appendChild(mk('span', null, (S.fuzzy ? 'No exact match for ' : 'Searching: ') + bits.join(' · ') + (S.fuzzy ? '. Closest styles:' : '')));
if ((P.min != null || P.max != null) && !hasPrices()) v.said.appendChild(mk('em', null, ' Sign in to filter by price.'));
}
renderChips(v);
}
function renderChips(v) {
var el = v.chips, left = el.scrollLeft; el.textContent = '';
if (!S.loaded) { el.hidden = true; return; }
var vals = values('style'), showLike = !!(L.loggedIn() || S.wk);
if (vals.length < 2 && !showLike) { el.hidden = true; return; } el.hidden = false;
if (showLike) {
var lo = likedOn(), ln = likedCount();
var lb = btn('bvs-chip bvs-like' + (lo ? ' bvs-act' : ''), '', lo ? 'Show every style' : 'Show only the styles in your wishlist', function () { setLiked(!lo); });
lb.appendChild(mk('span', 'bvs-hrt', '♥')); lb.appendChild(d.createTextNode('Wishlist')); lb.appendChild(mk('i', null, String(ln)));
lb.setAttribute('aria-pressed', String(lo)); el.appendChild(lb);
}
if (vals.length < 2) { el.scrollLeft = left; return; }
var cnt = counts('style'), sv = S.sel.style || {}, pv = (S.P && S.P.fac.style) || {}, anyOn = Object.keys(sv).length || Object.keys(pv).length;
var all = btn('bvs-chip' + (anyOn ? '' : ' bvs-act'), 'All styles', null, function () { delete S.sel.style; if (Object.keys(pv).length) setQ(dropFromQuery('style')); else apply(); });
all.setAttribute('aria-pressed', String(!anyOn)); el.appendChild(all);
vals.forEach(function (val) {
var on = !!(sv[val] || pv[val]), n = cnt[val] || 0;
var b = btn('bvs-chip' + (on ? ' bvs-act' : '') + (!n && !on ? ' bvs-zero' : ''), '', null, function () { toggle('style', val); });
b.appendChild(d.createTextNode(val)); b.appendChild(mk('i', null, String(n))); b.setAttribute('aria-pressed', String(on));
el.appendChild(b);
});
el.scrollLeft = left;
}
/* voice: the browser's mic for buyers without Wispr Flow */
var SR = window.SpeechRecognition || window.webkitSpeechRecognition, rec = null;
function micOn(on) { var v = S.v; if (!v) return; if (on) v.mic.classList.add('bvs-on'); else v.mic.classList.remove('bvs-on'); v.mic.setAttribute('aria-label', on ? 'Stop listening' : 'Search by voice'); }
function voice(inp) {
if (rec) { try { rec.stop(); } catch (e) {} return; }
if (!SR) { inp.focus(); say('Dictate into the search box with Wispr Flow, or type.'); return; }
var r = rec = new SR(), fin = '', v0 = U && vid();
r.lang = navigator.language || 'en-US'; r.interimResults = true; r.continuous = false; r.maxAlternatives = 1;
if (v0) v0.muted = true;   /* keep the video's sound out of the mic */
micOn(true);
say('Listening… say a style, wash or style #');
r.onresult = function (e) {
var txt = ''; for (var i = 0; i < e.results.length; i++) txt += e.results[i][0].transcript;
fin = txt.trim();
if (S.v && S.v.inp._sync) S.v.inp._sync(fin);
if (e.results[e.results.length - 1].isFinal) setQ(fin);
};
r.onerror = function (e) {
if (e.error === 'not-allowed' || e.error === 'service-not-allowed') say('The mic is blocked. Dictate with Wispr Flow in the search box, or allow the mic.');
else if (e.error === 'no-speech') say('Didn’t catch that. Tap the mic and try again.');
};
r.onend = function () {
if (rec === r) rec = null;
micOn(false);
var v1 = U && vid(); if (v1 && v1 === v0) v1.muted = U.muted;
if (fin) setQ(fin);
};
try { r.start(); } catch (e) { rec = null; micOn(false); inp.focus(); }
}
/* Filters & sort menu: covers the Shop panel */
function closeFilters() { if (!S.fd) return; var o = S.fd; S.fd = null; o.remove(); }
function openFilters() {
closeFilters();
var u = U; if (!u || u.mini) return;
if (u.fs && !u.list) openList();
var fd = mk('div', 'bvs-fd'); fd.setAttribute('role', 'dialog'); fd.setAttribute('aria-label', 'Filters and sort');
fd.addEventListener('click', L.stop); fd.addEventListener('keydown', function (e) { e.stopPropagation(); if (e.key === 'Escape') closeFilters(); });
var hd = mk('div', 'bvs-fdh'); hd.appendChild(mk('span', null, 'Filters & sort'));
var ca = btn('bvs-fgall', 'Collapse all', null, function () { var to = !ca._open; (ca._g || []).forEach(function (g) { setOpen(g, to); }); renderFilters(); });
hd.appendChild(ca); hd.appendChild(btn('bvs-fdx', '✕', 'Close filters', closeFilters));
var body = mk('div', 'bvs-fdb'), ft = mk('div', 'bvs-fdf');
ft.appendChild(btn('bvs-fdc', 'Clear all', null, clearAll));
ft.appendChild(btn('bvs-show', 'Show styles', null, closeFilters));
fd.appendChild(hd); fd.appendChild(body); fd.appendChild(ft);
u.panel.appendChild(fd);
S.fd = fd; renderFilters();
try { hd.lastChild.focus({ preventScroll: true }); } catch (e) {}
}
function renderFilters() {
var fd = S.fd; if (!fd) return;
var body = fd.querySelector('.bvs-fdb'), top = body.scrollTop, prices = hasPrices(), shown = [], allOpen = true; body.textContent = '';
/* one section: its heading opens and shuts it; a shut section shows what is picked in it */
function section(g, label, on, sum, clear, fill) {
var open = isOpen(g, on), sec = mk('div', 'bvs-fg' + (open ? '' : ' bvs-shut')), h = mk('div', 'bvs-fgh');
sec.setAttribute('data-g', g); shown.push(g); if (!open) allOpen = false;
var t = btn('bvs-fgt', '', null, function () { setOpen(g, !open); S.ff = g; renderFilters(); });
t.setAttribute('aria-expanded', String(open));
var ch = mk('span', 'bvs-chev'); setIcon(ch, 'M6 9l6 6 6-6'); t.appendChild(ch); t.appendChild(mk('span', null, label));
if (!open && sum) t.appendChild(mk('em', 'bvs-fgs', sum));
h.appendChild(t); if (clear) h.appendChild(clear); sec.appendChild(h);
if (open) fill(sec);
body.appendChild(sec);
}
var sortName = ''; SORTS.forEach(function (s) { if (s[0] === S.sort) sortName = s[1]; });
section('sort', 'Sort by', S.sort !== 'feat', S.sort !== 'feat' ? sortName : '', null, function (sec) {
var pills = mk('div', 'bvs-pills');
SORTS.forEach(function (s) {
if ((s[0] === 'plh' || s[0] === 'phl') && !prices) return;
var on = S.sort === s[0], b = btn('bvs-pill' + (on ? ' bvs-act' : ''), s[1], null, function () { S.sort = s[0]; apply(); });
b.setAttribute('aria-pressed', String(on)); pills.appendChild(b);
});
sec.appendChild(pills);
});
GROUPS.forEach(function (g) {
var vals = values(g[0]); if (vals.length < 2) return;
var cnt = counts(g[0]), sv = S.sel[g[0]] || {}, pv = (S.P && S.P.fac[g[0]]) || {}, lim = S.more[g[0]] ? 1e9 : 14;
var picked = vals.filter(function (v) { return sv[v] || pv[v]; });
var clear = Object.keys(sv).length ? btn('bvs-fgc', 'Clear', 'Clear ' + g[1], function () { delete S.sel[g[0]]; apply(); }) : null;
section(g[0], g[1], picked.length > 0, picked.join(', '), clear, function (sec) {
var pl = mk('div', 'bvs-pills');
vals.forEach(function (val, i) {
var on = !!(sv[val] || pv[val]), n = cnt[val] || 0;
var b = btn('bvs-pill' + (on ? ' bvs-act' : '') + (!n && !on ? ' bvs-zero' : ''), '', null, function () { toggle(g[0], val); });
b.appendChild(d.createTextNode(val)); b.appendChild(mk('i', null, String(n))); b.setAttribute('aria-pressed', String(on));
if (i >= lim && !on) b.hidden = true;
pl.appendChild(b);
});
sec.appendChild(pl);
if (vals.length > lim) sec.appendChild(btn('bvs-fgm', 'Show all ' + vals.length, null, function () { S.more[g[0]] = 1; renderFilters(); }));
});
});
if (!prices) body.appendChild(mk('p', 'bvs-fnote', 'Sign in to see wholesale prices and sort or filter by price.'));
body.scrollTop = top;
var ca = fd.querySelector('.bvs-fgall'); if (ca) { ca._g = shown; ca._open = allOpen; ca.textContent = allOpen ? 'Collapse all' : 'Expand all'; ca.setAttribute('aria-label', allOpen ? 'Collapse every filter section' : 'Expand every filter section'); }
if (S.ff) { var ft = body.querySelector('[data-g="' + S.ff + '"] .bvs-fgt'); S.ff = null; if (ft) try { ft.focus({ preventScroll: true }); } catch (e) {} }
var n = S.items.length;
fd.querySelector('.bvs-show').textContent = n ? 'Show ' + n + (n === 1 ? ' style' : ' styles') : 'No styles match';
}
function render() { if (S.v) paintView(S.v); renderFilters(); refresh(); }
/* the video plays the styles that match; the style on screen keeps playing when it still matches */
function refresh() {
var u = U; if (!u) return;
if (S.items.length) {
var cur = u.items[u.i], same = u.items.length === S.items.length && u.items.every(function (x, k) { return x === S.items[k]; });
if (!same || !u.started) {
u.items = S.items.slice(); buildBars();
var ni = cur ? u.items.indexOf(cur) : -1;
if (ni < 0 || !u.started) { u.i = Math.max(0, ni); if (!u.started) applyMute(); play(); }
else { u.i = ni; paintTag(); }
}
} else if (!u.started) u.center.textContent = S.loaded ? 'No styles match. Clear the search to see every style.' : 'Loading…';
renderList(); renderCard();
}

/* ---------- player ---------- */
function build() {
var u = { items: [], i: 0, muted: true, paused: false, el: 0, sheet: null, list: false, mini: false, desk: false, fs: false, offs: [] };
u.wrap = mk('div', 'bsv'); u.wrap.setAttribute('role', 'dialog'); u.wrap.setAttribute('aria-modal', 'true'); u.wrap.setAttribute('aria-label', 'Oneso Shop Video');
u.stage = mk('div', 'bsv-stage'); u.media = mk('div', 'bsv-media'); u.center = mk('div', 'bsv-center', 'Loading…');
u.bars = mk('div', 'bsv-bars'); u.tag = mk('div', 'bsv-tag'); u.thumbs = mk('div', 'bsv-thumbs'); u.rail = mk('div', 'bsv-rail');
var tl = mk('div', 'bsv-tap l'), tr = mk('div', 'bsv-tap r'); tl.addEventListener('click', function (e) { e.stopPropagation(); go(u.i - 1); }); tr.addEventListener('click', function (e) { e.stopPropagation(); go(u.i + 1); });
u.panel = mk('div', 'bsv-panel'); var ph = mk('div', 'bsv-ph'); u.phT = mk('span', null, 'Shop'); ph.appendChild(u.phT); ph.appendChild(btn('bsv-phx', '✕', 'Close the product list', closeList));
u.ctl = controls();
u.listEl = mk('div', 'bsv-list'); u.panel.appendChild(ph); u.panel.appendChild(u.ctl.box); u.panel.appendChild(u.listEl); u.panel.addEventListener('click', L.stop);
u.bottom = mk('div', 'bsv-bottom'); u.allBtn = btn('bsv-all bvs-all', '', 'Search and filter styles', function () { openList(true); }); u.cardSlot = mk('div');
u.tfs = btn('bay-tfs', '', 'Turn sound on', function () { if (!u.muted) return; u.muted = false; applyMute(); var v = vid(); if (v && v.paused && !u.paused) v.play().catch(function () {}); flash('Sound on'); });
setIcon(u.tfs, ICON.off); u.tfs.appendChild(mk('span', null, 'Tap for sound')); u.tfs.hidden = true;
var ctl = mk('div', 'bsv-ctl'); u.prevB = btn('', '', 'Previous style', function () { go(u.i - 1); }); setIcon(u.prevB, ICON.prev);
u.playB = btn('', '', 'Pause', function () { setPaused(!u.paused); }); setIcon(u.playB, ICON.pause);
u.nextB = btn('', '', 'Next style', function () { go(u.i + 1); }); setIcon(u.nextB, ICON.next);
u.seek = mk('input'); u.seek.type = 'range'; u.seek.min = '0'; u.seek.max = '1000'; u.seek.value = '0'; u.seek.setAttribute('aria-label', 'Video position'); u.seek.addEventListener('click', L.stop);
u.seek.addEventListener('input', function () { var f = u.seek.value / 1000, v = vid(); if (v && v.duration) v.currentTime = f * v.duration; else u.el = f * photoTotal(); });
u.time = mk('span', null, '0:00');
ctl.appendChild(u.prevB); ctl.appendChild(u.playB); ctl.appendChild(u.nextB); ctl.appendChild(u.seek); ctl.appendChild(u.time);
u.bottom.appendChild(u.tfs); u.bottom.appendChild(u.allBtn); u.bottom.appendChild(u.cardSlot); u.bottom.appendChild(ctl);
u.muteB = ibtn(ICON.on, 'Mute sound', function () { u.muted = !u.muted; applyMute(); flash(u.muted ? 'Sound off' : 'Sound on'); });
u.findB = ibtn(IC.search, 'Search and filter styles', function () { closeSheet(true); if (u.desk) { try { u.ctl.inp.focus(); } catch (e) {} } else openList(true); });
u.rail.appendChild(ibtn(ICON.close, 'Close', close)); u.rail.appendChild(u.findB); u.rail.appendChild(ibtn(ICON.mini, 'Minimize video', minimize)); u.rail.appendChild(u.muteB); u.rail.appendChild(ibtn(ICON.share, 'Share this Shop Video', function () { L.share(u.handles, u.label, flash); }));
u.rail.appendChild(ibtn('M3 3h2.5l2.4 11.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.5L21.5 7H6.2 M10.5 20.5a1 1 0 1 1-2 0a1 1 0 1 1 2 0 M19 20.5a1 1 0 1 1-2 0a1 1 0 1 1 2 0', 'View cart', function () { openCart(); }));
u.mc = mk('div', 'bsv-mc'); var mX = ibtn(ICON.close, 'Close video', close), mM = ibtn(ICON.on, 'Mute sound', function () { u.muteB.click(); }), mB = ibtn(ICON.big, 'Expand video', function () { expand(); });
mX.className = 'bsv-mx'; mM.className = 'bsv-mm'; mB.className = 'bsv-mb'; u.mM = mM; u.mc.appendChild(mX); u.mc.appendChild(mM); u.mc.appendChild(mB);
[u.media, u.center, u.bars, u.tag, tl, tr, u.thumbs, u.rail, u.bottom, u.mc].forEach(function (n) { u.stage.appendChild(n); });
u.wrap.appendChild(u.stage);
u.stage.addEventListener('click', function (e) { if (u.mini && !u.mc.contains(e.target)) { e.stopPropagation(); expand(); } }, true);
u.wrap.addEventListener('click', function (e) { if (e.target === u.wrap && u.desk) close(); });
var on = function (t, ev, fn, o) { t.addEventListener(ev, fn, o); u.offs.push(function () { t.removeEventListener(ev, fn, o); }); };
on(d, 'keydown', function (e) {
if (u.mini || u.cart) return;   /* the cart is open over the player: its keys belong to the cart */
var tg = (e.target && e.target.tagName) || '';
if (e.key === 'Escape') { if (S.fd) closeFilters(); else if (u.sheet) closeSheet(); else if (u.list) closeList(); else close(); return; }
if (/INPUT|SELECT|TEXTAREA/.test(tg) || u.sheet || S.fd) return;
if (e.key === '/' && S.all.length > 1) { e.preventDefault(); u.findB.click(); }
else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(u.i + 1); }
else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(u.i - 1); }
else if (e.key === ' ') { e.preventDefault(); setPaused(!u.paused); }
});
var sx = null, sy = 0;
on(u.stage, 'touchstart', function (e) { sx = u.sheet || u.list || u.mini || S.fd || e.target.closest('input, .bsv-ctl, .bsv-panel') ? null : e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
on(u.stage, 'touchmove', function (e) { if (sx != null && e.cancelable) e.preventDefault(); }, { passive: false });
on(u.stage, 'touchend', function (e) {
if (sx == null) return; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
if (Math.abs(dy) > 50 && Math.abs(dy) > Math.abs(dx)) go(u.i + (dy < 0 ? 1 : -1)); else if (Math.abs(dx) > 60) go(u.i + (dx < 0 ? 1 : -1));
}, { passive: true });
u.wt = 0;
on(u.stage, 'wheel', function (e) { if (u.sheet || u.list || u.mini || e.target.closest('.bsv-panel')) return; e.preventDefault(); var now = Date.now(); if (Math.abs(e.deltaY) < 25 || now - u.wt < 800) return; u.wt = now; go(u.i + (e.deltaY > 0 ? 1 : -1)); }, { passive: false });
on(window, 'resize', layout);
u.tick = setInterval(function () { if (U !== u) return; var it = u.items[u.i]; if (!it || it.video || u.paused) return; u.el += 100; if (u.el >= photoTotal()) { if (u.sheet) u.el = 0; else { go(u.i + 1, true); return; } } photoFrame(); }, 100);
return u;
}
function layout() {
var u = U; if (!u || u.mini) return;
var m = isMobile();
if (m && !u.fs) { u.fs = true; u.desk = false; u.list = false; u.panel.remove(); u.stage.style.aspectRatio = ''; u.wrap.className = 'bsv bsv-fs'; if (u.sheet) { u.stage.appendChild(u.sheet); u.stage.classList.add('bsv-dimv'); } }
else if (!m && !u.desk) { u.desk = true; u.fs = false; u.list = false; u.wrap.className = 'bsv bsv-dk'; u.wrap.insertBefore(u.panel, u.stage); u.stage.classList.remove('bsv-dimv'); if (u.sheet) u.panel.appendChild(u.sheet); }
renderList(); renderCard();
}
function flash(text) { var u = U; if (!u) return L.toast(text); [].forEach.call(u.stage.querySelectorAll('.bsv-hint'), function (n) { n.remove(); }); var f = mk('div', 'bsv-hint', text); f.setAttribute('role', 'status'); u.stage.appendChild(f); setTimeout(function () { f.remove(); }, 2200); }
function fit(w, h) { var u = U; if (!u || !u.desk || !w || !h) return; var r = Math.max(0.5, Math.min(1, w / h)); u.stage.style.aspectRatio = String(r); }
function vid() { return U && U.media.querySelector('video'); }
/* "Tap for sound" shows while a video is playing silently (not on photos, not once the sound is on) */
function paintTfs() { var u = U; if (!u || !u.tfs) return; var it = u.items[u.i]; u.tfs.hidden = !(u.muted && it && it.video); }
function applyMute() { var u = U, v = vid(); if (v) v.muted = u.muted; [u.muteB, u.mM].forEach(function (b) { setIcon(b, u.muted ? ICON.off : ICON.on); b.setAttribute('aria-label', u.muted ? 'Turn sound on' : 'Mute sound'); }); u.muteB.setAttribute('aria-pressed', String(u.muted)); paintTfs(); }
function setPaused(p) { var u = U; u.paused = p; var v = vid(); if (v) { if (p) v.pause(); else v.play().catch(function () {}); } setIcon(u.playB, p ? ICON.play : ICON.pause); u.playB.setAttribute('aria-label', p ? 'Play' : 'Pause'); }
function photoTotal() { var it = U.items[U.i]; return PHOTO_MS * Math.max(1, Math.min((it && it.photos.length) || 1, 3)); }
function photoFrame() {
var u = U, it = u.items[u.i], tot = photoTotal(), n = Math.min(Math.max(0, it.photos.length - 1), Math.floor(u.el / PHOTO_MS));
if (n !== u.pn) { u.pn = n; u.media.textContent = ''; var im = mk('img'); im.alt = it.title; im.onload = function () { fit(im.naturalWidth, im.naturalHeight); }; im.src = L.sized(it.photos[n] || it.img, 1000); u.media.appendChild(im); }
progress(u.el / tot, u.el / 1000, tot / 1000);
}
function buildBars() {
var u = U; u.oneBar = u.items.length > 40;
u.bars.innerHTML = u.oneBar ? '<div class="bsv-bar"><i></i></div>' : u.items.map(function () { return '<div class="bsv-bar"><i></i></div>'; }).join('');
}
function progress(f, cur, dur) {
var u = U, bars = u.bars.children;
if (u.oneBar) { if (bars[0]) bars[0].firstChild.style.width = Math.min(100, f * 100) + '%'; }
else for (var b = 0; b < bars.length; b++) bars[b].firstChild.style.width = (b < u.i ? 100 : b > u.i ? 0 : Math.min(100, f * 100)) + '%';
if (d.activeElement !== u.seek) u.seek.value = String(Math.round(f * 1000));
u.time.textContent = mmss(cur) + ' / ' + mmss(dur);
}
function paintTag() { var u = U, it = u.items[u.i]; u.tag.textContent = 'SHOP VIDEO · ' + (u.i + 1) + '/' + u.items.length + (it && !it.video ? ' · PHOTOS' : ''); }
function go(n, auto) {
var u = U; if (!u || !u.items.length) return;
n = (n + u.items.length) % u.items.length; if (n === u.i && auto !== 'force' && !auto) return;
u.i = n; play();
}
function play() {
var u = U, it = u.items[u.i]; if (!it) return;
u.media.textContent = ''; u.el = 0; u.pn = -1; u.center.style.display = 'none'; u.started = true;
paintTag();
if (it.video) {
var v = mk('video'); v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.preload = 'auto'; v.muted = u.muted; if (it.video.poster) v.poster = L.sized(it.video.poster, 1000); v.src = it.video.url;
v.addEventListener('timeupdate', function () { if (v.duration) progress(v.currentTime / v.duration, v.currentTime, v.duration); });
v.addEventListener('loadedmetadata', function () { fit(v.videoWidth, v.videoHeight); });
v.addEventListener('ended', function () { if (u.sheet) { v.currentTime = 0; v.play().catch(function () {}); } else go(u.i + 1, true); });
v.addEventListener('error', function () { if (U !== u || !v.isConnected) return; it.video = null; play(); });
u.media.appendChild(v);
/* only when the browser will not play it with sound does it go silent ("Tap for sound" then shows); a start cut short by the next style is not that */
if (!u.paused) v.play().catch(function (e) { if (U !== u || !v.isConnected || !e || e.name !== 'NotAllowedError' || v.muted) return; u.muted = true; applyMute(); v.play().catch(function () {}); });
} else photoFrame();
if (u.vh) u.vh.remove(); u.vh = null;
if (!it._vh && it.full) { it._vh = L.heart(flash); it._vh.bind(it.full); }
if (it._vh) { u.vh = it._vh.el; u.rail.insertBefore(u.vh, u.muteB); }
var nx = u.items[(u.i + 1) % u.items.length]; if (nx && nx.video && nx !== it) { var pre = mk('link'); pre.rel = 'preload'; pre.as = 'video'; pre.href = nx.video.url; d.head.appendChild(pre); }
paintTfs(); renderCard(); renderList();
}
function renderCard() {
var u = U; if (!u) return; var it = u.items[u.i]; u.cardSlot.textContent = ''; u.thumbs.textContent = '';
var n = S.items.length, few = S.loaded ? S.all.length < 2 : (u.handles || []).length < 2;   /* one style: no search box */
u.allBtn.textContent = '';
var ai = mk('span', 'bvs-ai'); setIcon(ai, IC.search); u.allBtn.appendChild(ai);
u.allBtn.appendChild(d.createTextNode(S.loaded ? 'Search & filter · ' + n + (n === 1 ? ' style' : ' styles') + ' ›' : 'Search & filter ›'));
u.allBtn.style.display = S.all.length > 1 ? '' : 'none';
u.phT.textContent = 'Shop' + (S.loaded ? ' · ' + n : '');
u.ctl.box.hidden = few; u.findB.style.display = few ? 'none' : '';
if (!it) return;
var card = btn('bsv-card', '', 'Shop ' + it.title, function () { openSheet(it); }), th = mk('div', 'bsv-thumb'), mid = mk('div'); bg(th, it.img, 200); mid.style.cssText = 'flex:1;min-width:0';
mid.appendChild(mk('div', 'bsv-card-t', it.title)); if (it.sn) mid.appendChild(mk('div', 'bsv-card-p', it.sn));
var pp = L.priceParts(it.price, it.m); if (pp.length) mid.appendChild(L.priceRow('bsv-card-pr', pp));
card.appendChild(th); card.appendChild(mid); card.appendChild(mk('span', 'bsv-shop', 'Shop now')); u.cardSlot.appendChild(card);
if (u.desk) { var tb = btn('bsv-tb', '', 'Shop ' + it.title, function () { openSheet(it); }), ti = mk('i'); bg(ti, it.img, 200); tb.appendChild(ti); if (it.sn) tb.appendChild(mk('span', null, it.sn)); u.thumbs.appendChild(tb); }
}
function row(it) {
var u = U, r = mk('div', 'bsv-li'), im = mk('div', 'bsv-li-im'), mid = mk('div', 'bsv-li-m'), pp = L.priceParts(it.price, it.m);
r.setAttribute('role', 'button'); r.tabIndex = 0; r.setAttribute('aria-label', 'Shop ' + it.title);
var pick = function () { var k = u.items.indexOf(it); if (k > -1 && k !== u.i) go(k, 'force'); openSheet(it); };
r.addEventListener('click', function (e) { e.stopPropagation(); pick(); });
r.addEventListener('keydown', function (e) { if (e.target === r && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pick(); } });
bg(im, it.img, 200);
if (it === u.items[u.i]) mid.appendChild(mk('div', 'bsv-li-f', 'Showing now'));
mid.appendChild(mk('div', 'bsv-li-t', it.title)); if (it.sn) mid.appendChild(mk('div', 'bsv-li-p', it.sn));
if (it.sub) mid.appendChild(mk('div', 'bvs-li-s', it.sub));
if (pp.length) mid.appendChild(L.priceRow('bsv-li-pr', pp));
mid.appendChild(mk('div', 'bsv-li-v', it.video ? '▶ Video' : 'Photos · no video yet'));
if (!it._h) { it._h = L.heart(flash); if (it.full) it._h.bind(it.full); }
r.appendChild(im); r.appendChild(mid); r.appendChild(it._h.el); r.appendChild(mk('span', 'bsv-li-c', '›'));
return r;
}
function renderList() {
var u = U; if (!u || (!u.desk && !u.list)) return;
var el = u.listEl, top = el.scrollTop, list = S.items; el.textContent = '';
if (!list.length) {
var e = mk('div', 'bvs-empty');
e.appendChild(mk('p', null, !S.loaded ? 'Loading styles…' : likedOn() && !likedCount() ? 'No styles in your wishlist yet. Tap ♥ on any style to save it.' : S.all.length ? 'No styles match.' : 'No styles to show.'));
if (S.loaded && filtersOn()) e.appendChild(btn('bvs-clrall', 'Clear search and filters', null, clearAll));
el.appendChild(e); return;
}
list.forEach(function (it) { el.appendChild(row(it)); });
el.scrollTop = top;
}
function openList(focus) {
var u = U; if (!u) return;
if (u.fs && !u.list) { u.list = true; u.stage.appendChild(u.panel); renderList(); }
if (focus && !u.ctl.box.hidden) setTimeout(function () { try { u.ctl.inp.focus(); } catch (e) {} }, 60);
}
function closeList() { var u = U; if (!u || !u.list) return; if (S.fd && u.panel.contains(S.fd)) closeFilters(); u.list = false; u.panel.remove(); }
function openSheet(it) {
var u = U; closeSheet(true); if (S.fd && u.panel.contains(S.fd)) closeFilters();
u.sheet = L.openSheet({ host: u.desk ? u.panel : u.stage, handle: it.h, title: it.title, img: it.img, flash: flash, backLabel: u.desk ? 'Back to all products' : 'Back to video', onBack: function () { closeSheet(); }, onCart: openCart });
if (!u.desk) u.stage.classList.add('bsv-dimv');
}
function closeSheet(now) {
var u = U; if (!u || !u.sheet) return; var s0 = u.sheet; u.sheet = null; u.stage.classList.remove('bsv-dimv');
if (now) s0.remove(); else { s0.classList.add('bsv-out'); setTimeout(function () { s0.remove(); }, 250); }
}
/* Cart button (and View cart in the product panel after adding): the SparkLayer cart slides in on the right, over the
   player (the video pauses). Closing the cart goes back to the video, which plays on; the buyer never leaves the player.
   Without SparkLayer, the cart page opens in a new tab. */
function openCart() {
var u = U, Sp = window.spark; if (!u) return;
if (!Sp || !Sp.openDrawer) { window.open(base + 'cart', '_blank', 'noopener'); return; }
var wasPaused = u.paused; if (!wasPaused) setPaused(true);
u.cart = true; u.wrap.style.zIndex = '99990';   /* just under the cart (SparkLayer's cart sits at 99999) */
try { Sp.openDrawer(); } catch (e) {}
var seen = false, t0 = Date.now();
clearInterval(u.cartT);
u.cartT = setInterval(function () {
var sd = d.querySelector('spark-drawer'), op = !!(sd && sd.shadowRoot && sd.shadowRoot.querySelector('[class*="z-99999"]'));
if (op) { seen = true; return; }
if (!seen && Date.now() - t0 < 5000 && U === u) return;   /* still opening */
clearInterval(u.cartT); u.cart = false; u.wrap.style.zIndex = '';
if (!seen) flash('The cart did not open. Please try again.');
if (U === u && !wasPaused) setPaused(false);
}, 250);
}
function minimize() { var u = U; if (u.mini) return; closeFilters(); u.mini = true; closeSheet(true); closeList(); u.wrap.classList.add('bsv-mini'); d.documentElement.style.overflow = u.prevOv; }
function expand() { var u = U; if (!u.mini) return; u.mini = false; u.wrap.classList.remove('bsv-mini'); d.documentElement.style.overflow = 'hidden'; layout(); }
function close() {
var u = U; if (!u) return;
closeFilters(); if (rec) { try { rec.abort(); } catch (e) {} }
U = null;
var v = u.media.querySelector('video'); if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
clearInterval(u.tick); clearInterval(u.cartT); u.offs.forEach(function (f) { f(); }); u.wrap.remove(); d.documentElement.style.overflow = u.prevOv;
}
function open(handles, label) {
if (U) close();
S = fresh(); findCss();
var u = U = build(); S.v = u.ctl; u.handles = handles; u.label = label || 'Shop Video'; paintView(S.v);
u.prevOv = d.documentElement.style.overflow; d.documentElement.style.overflow = 'hidden';
d.body.appendChild(u.wrap); layout();
function none(msg) { u.center.textContent = msg; S.loaded = true; renderCard(); renderList(); }
if (!handles.length) { none('Add styles to this delivery to build its Shop Video.'); return; }
Promise.all(handles.map(function (h) { return L.load(h, function () { if (U === u) { renderList(); renderCard(); } }); })).then(function (list) {
if (U !== u) return;
list = list.filter(Boolean);
var all = list.filter(function (x) { return x.video; }).concat(list.filter(function (x) { return !x.video; }));
if (!all.length) { none('We couldn’t load these styles. Please try again.'); return; }
all.forEach(function (it, n) { prep(it, null, n); });
S.all = all; S.loaded = true;
S.wk = all.some(function (it) { return it._h && it._h.el.style.display !== 'none'; });
buildPhraseIndex(); all.forEach(watchLike);
apply();   /* plays the first style; the player always starts silent, "Tap for sound" turns the sound on */
if (u.fs && all.length > 1) setTimeout(function () { if (U === u && !u.list) flash('Swipe up for the next style'); }, 2600);
/* rise, color, season, stretch, status and inseam (metafields) arrive a moment later; search and filters then use them too */
var left = all.length;
all.forEach(function (it) { meta(it.h).then(function (m) { if (U !== u) return; if (m) prep(it, m, it.n); if (--left === 0) { buildPhraseIndex(); apply(); } }); });
});
}
window.OnesoShopVideo = { open: open, close: close, search: function (q) { if (U) setQ(q); }, clear: function () { if (U) clearAll(); } };
try {
var qs = new URLSearchParams(location.search), hv = qs.get('shop_video');
if (hv) { var hs = hv.split(',').map(function (h) { return h.trim(); }).filter(function (h) { return /^[a-z0-9\-]+$/i.test(h); }).slice(0, 60); if (hs.length) open(hs, (qs.get('sv_label') || 'Shop Video').slice(0, 80)); }
} catch (err) {}
})();
